import { api } from './client';

// Вход по телефону в PWA (Plusofon flash-call). Контракт бэка: docs/pwa-phone-login-architecture.md.
// Сессия ставится httpOnly-cookie сервером (токен в JS не приходит).

export interface PhoneLoginInitiateResult {
  retryAfterSeconds: number;
}

export interface PhoneLoginCustomer {
  id: string;
  venueId: string;
  firstName: string;
}

export interface PhoneLoginVenueOption {
  venueId: string;
  name: string;
}

// Discriminated union — форма фиксирована под мультивеню (добавление заведений = drop-in).
// 'register' — аккаунтов нет: владелец номера регистрируется (единый флоу, решение 2026-07-21).
export type PhoneLoginConfirmResult =
  | { status: 'authenticated'; customer: PhoneLoginCustomer }
  | { status: 'select_venue'; identityToken: string; venues: PhoneLoginVenueOption[] }
  | { status: 'register'; identityToken: string };

// Шаг 1: запросить звонок. Ответ единый (клиент/не-клиент неразличимы).
export function initiatePhoneLogin(phone: string): Promise<PhoneLoginInitiateResult> {
  return api.post<PhoneLoginInitiateResult>('/auth/phone-login/initiate', { phone });
}

// Шаг 2: подтвердить код. authenticated → сессия в cookie; select_venue → нужен выбор заведения.
export function confirmPhoneLogin(phone: string, code: string): Promise<PhoneLoginConfirmResult> {
  return api.post<PhoneLoginConfirmResult>('/auth/phone-login/confirm', { phone, code });
}

// Шаг 3 (мультивеню): выбрать заведение по identityToken → сессия в cookie.
export function selectLoginVenue(
  identityToken: string,
  venueId: string
): Promise<{ status: 'authenticated'; customer: PhoneLoginCustomer }> {
  return api.post('/auth/phone-login/select-venue', { identityToken, venueId });
}

// Завершение регистрации: identityToken (телефон подтверждён) + имя → клиент создан, сессия в cookie.
// referralCode — код из ссылки друга (?ref=): сервер связывает приглашённого с пригласившим (как /users/me
// мини-аппа). Нет кода — поле не отправляем.
export function registerPhoneAccount(
  identityToken: string,
  firstName: string,
  referralCode?: string
): Promise<{ status: 'authenticated'; customer: PhoneLoginCustomer }> {
  return api.post('/auth/phone-login/register', {
    identityToken,
    firstName,
    ...(referralCode ? { referralCode } : {}),
  });
}

// Выход: очистка серверной cookie-сессии.
export function logoutSession(): Promise<{ ok: boolean }> {
  return api.post('/auth/phone-login/logout', {});
}
